import React, { ReactElement } from 'react';
import Search from './search';
import Krets from './krets';
import { useSelector } from 'react-redux';
import { RemoteOrganizer } from '../../../../types';

export default function ListFilter(): ReactElement {
  const { organizers } = useSelector((state: { organizers: RemoteOrganizer[] }) => ({ organizers: state.organizers }));
  return (
    <div>
      <Search />
      <Krets organizers={organizers} />
    </div>
  );
}
